import { Paper, styled } from "@mui/material";

export const MainContentContainer = styled('div')(({ theme }) => ({
    height: '100vh',
    overflow: 'auto',
    display: 'flex',
    width: '100%',
    minWidth: '375px',
    backgroundColor: theme.barekam.background
}))

export const AuthContentContainer = styled(MainContentContainer)(() => ({
    backgroundColor: 'unset',
    paddingTop: '40px',
}))

export const Content = styled('div')(() => ({
    width: '100%',
    minHeight: '100%',
    height: 'max-content',
    paddingTop: '60px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center'
}))

export const LoadingSpinnerContainer = styled(Paper)(() => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '1rem',
    gap: '0.5rem'
}))